export type Task = 'ride' | 'composition' | 'camera' | 'export';
export const TASKS: { id: Task; title: string; shortTitle: string; subtitle: string }[] = [
  { id: 'ride', title: 'Video Setup', shortTitle: 'Setup', subtitle: 'Footage, title & format' },
  { id: 'composition', title: 'Map', shortTitle: 'Map', subtitle: 'Map & information' },
  { id: 'camera', title: 'Camera', shortTitle: 'Cam', subtitle: 'Shape the journey' },
  { id: 'export', title: 'Review & Export', shortTitle: 'Exp', subtitle: 'Check your film' },
];
